import { render, staticRenderFns } from "./ProgramChooser.vue?vue&type=template&id=77c8ebff&scoped=true"
import script from "./ProgramChooser.vue?vue&type=script&lang=js"
export * from "./ProgramChooser.vue?vue&type=script&lang=js"
import style0 from "./ProgramChooser.vue?vue&type=style&index=0&id=77c8ebff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c8ebff",
  null
  
)

export default component.exports